import { useMemo } from "react";
import ModuleDate from "../../modules/date";

export default function CohortRangeLabel({
  startDate = "",
  endDate = ""
}: {
  startDate: string;
  endDate: string;
}) {
  const result = useMemo(() => {
    if (
      !(typeof startDate === "string" && startDate.trim() !== "") ||
      !(typeof endDate === "string" && endDate.trim() !== "")
    ) {
      return "-";
    }

    return ModuleDate.getSubmissionDateFormat(startDate, true) +
      " to " +
      ModuleDate.getSubmissionDateFormat(endDate, true);
  }, [startDate, endDate]);

  return <>{result}</>;
}
